import React from "react";
import Icon from "../Icon";
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";

export default  ({ title, text, url }) => {
    const handleShare = async () => {
        if (navigator.share) {
            // const response = await fetch(url);
            // const blob = await response.blob();

            const shareData = {
                title: title,
                text: text,
                url: window.location.href,
                // files: [
                //     new File([blob], "image.png", { type: blob.type }),
                // ],
            };

            try {
                await navigator.share(shareData);
                alert("Content shared successfully!");
            } catch (err) {
                console.error("Error sharing content:", err);
            }
        } else {
            alert("Web Share API is not supported in your browser.");
        }
    };

    return (
        <span className="ms-3 text-saffron px-3 py-1 border border-1 border-warning rounded-4 text-nowrap cursor-pointer" style={{ maxHeight: "2.4rem"}} onClick={handleShare}><Icon icon={faArrowUpFromBracket} className="me-3" />Share</span>
    );
};

// Usage Example
// import React from "react";
// import ReactDOM from "react-dom";
// import WebShareComponent from "./WebShareComponent";

// ReactDOM.render(<WebShareComponent />, document.getElementById("root"));
